export function marketplaceUrl(baseUrl: string | null | undefined, path = '/'): string {
  if (!baseUrl) return path;
  return new URL(path, baseUrl).toString();
}

/**
 * Marketplace deep-link to the agent's store page. The marketplace renders
 * the agent landing via a query param (`/?agent=<id>`), not a path segment;
 * `/agents/<id>` 404s in production.
 */
export function marketplaceAgentStoreUrl(
  baseUrl: string | null | undefined,
  agentId: string,
): string {
  const query = `/?agent=${encodeURIComponent(agentId)}`;
  if (!baseUrl) return query;
  return new URL(query, baseUrl).toString();
}
